// extracted by mini-css-extract-plugin
export default {"next-button":"NewArrival_next-button__W35SW","prev-button":"NewArrival_prev-button__wPlEL"};